// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.toggle-button[data-v-1803f542] {\n  background-color: #fff;\n}\n", ""]);
// Exports
module.exports = exports;
